/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;flex-direction:column;justify-content:center;align-items:center;height:100vh;color:#597996}img[_ngcontent-%COMP%]{display:block;margin:0 auto;max-width:90%;height:auto}h1[_ngcontent-%COMP%]{font-size:4rem;font-weight:300;margin-top:50px;max-width:90%;text-align:center}.mat-raised-button.mat-accent[_ngcontent-%COMP%]{color:#fff;background-color:#597996;min-width:220px;line-height:46px;max-width:90%}"];
export { styles as styles };
